const theme = {
  colors: {
    base: '#121212', // Black
    secondary: '#e9e9e9', // Medium Gray
    tertiary: '#f3f3f3', // Light Gray
    highlight: '#5b8bf7', // Light Blue
  },
  sizes: {
    maxWidth: '950px',
  },
  responsive: {
    small: '35em',
    medium: '51em',
    large: '70em',
    veryLarge: '220em',
  },
}

export default theme
